import { TActions } from '../../../types/actions';
import { EBetPositionStatus, IBetPositionState } from './types';
import { LOAD_BET_POSITION_FAIL, LOAD_BET_POSITION_START, LOAD_BET_POSITION_SUCCESS } from './actions';

export const defaultState: IBetPositionState = {
  status: EBetPositionStatus.initial,
  positionByService: {},
};

export function betPosition(state: IBetPositionState = defaultState, action: TActions): IBetPositionState {
  switch (action.type) {
    case LOAD_BET_POSITION_START: {
      return {
        ...state,
        status: EBetPositionStatus.pending,
      };
    }

    case LOAD_BET_POSITION_SUCCESS: {
      return {
        ...state,
        status: EBetPositionStatus.success,
        positionByService: action.payload,
      };
    }

    case LOAD_BET_POSITION_FAIL: {
      return {
        ...state,
        status: EBetPositionStatus.fail,
      };
    }

    default:
      return state;
  }
}
